<template>
	<LayoutOffcanvasStandard ref="offcanvas" id="customer-modal-status" :title="customer?.name" subtitle="Cambiar estado del cliente" bodyClass="container-md vstack gap-5">
		<template #body>
			<div class="vstack gap-5">
				<CommonFormInputSelect v-model="form.status" title="Nuevo estado" :options="statusesOptions" :disableds="statusesDisableds" />
				<CommonFormInputTextarea v-model="form.observations" title="Observaciones" subtitle="Opcional" placeholder="Ingrese una observacion" />
			</div>
		</template>
		<template #footer>
			<button type="button" class="btn rounded-pill w-100 btn-primary" :disabled="submitting" @click="submit">Guardar</button>
		</template>
	</LayoutOffcanvasStandard>
</template>

<script>
	import { ref, reactive, computed, onMounted, inject, getCurrentInstance } from 'vue';
	import { Modal, Offcanvas } from 'bootstrap';
	import _ from 'lodash';
	import composableForm from '@/composables/form';
	import CustomerRepository from '@/repositories/modules/Customer';

	export default {
		setup(props) {
			const { submitting, catchError } = composableForm();
			const instance = getCurrentInstance();
			const $env = inject('$env');
			const statusesOptions = computed(() => _.mapValues($env.MODEL.CustomerUser.statuses, (role) => role.title));
			const statusesDisableds = computed(() => _.keys(_.pickBy($env.MODEL.CustomerUser.statuses, (item) => item.selectable === false)));
			const offcanvas = ref(null);
			const customer = ref(null);

			const form = reactive({
				status: null,
				observations: null
			});

			const closeOpenOffcanvas = () => {
				if(document.querySelector('.offcanvas.show')) {
					var offcanvasShowed = Offcanvas.getInstance(document.querySelector('.offcanvas.show'));
					offcanvasShowed.hide();
				}

				if(document.querySelector('.modal.show')) {
					var modalShowed = Modal.getInstance(document.querySelector('.modal.show'));
					modalShowed.hide();
				}
			}

			const customerStatus = (dataCustomer = null) => {
				closeOpenOffcanvas();
				customer.value = dataCustomer;
				form.status = customer.value.pivot.status;
				form.observations = null;
				offcanvas.value.offcanvas.show();
			}

			const submit = async () => {
				submitting.value = true;

				await CustomerRepository.history(customer.value.id, form).then((response) => {
					offcanvas.value.offcanvas.hide();

					if(instance.proxy?.$customerRefresh && typeof instance.proxy.$customerRefresh === 'function')
						instance.proxy.$customerRefresh();
				}).catch((e) => catchError(e, true));

				submitting.value = false;
			}

			onMounted(() => {
				if(instance) instance.appContext.config.globalProperties.$customerStatus = customerStatus;
			});

			return { submitting, statusesOptions, statusesDisableds, customer, offcanvas, submit, form };
		}
	}
</script>